<template>
  <div>
    <div class="page-content">
      <div class="container">
        <div class="main-container container-fh__content p-trial-period-expired" style="padding: 0px;">
          <img src="/static/img/modal/1.svg" alt="" class="p-trial-period-expired__image" width="100px">
          <div class="col-md-8" v-if="reqSuccess == true">
             <div class="p-trial-period-expired__desc">Your request has been submitted!</div>
              <div class='panel-body' style="text-align: center !important;">
                You will recieve a notification when granted
                Thanks.
              </div>
          </div>
          <div class="col-md-8" v-if="reqSuccess == false">
            <h2 class="p-trial-period-expired__heading">Device Registration</h2>
            <div class="p-trial-period-expired__desc">Please kindly fill the form below for request</div>
            <div class="p-trial-period-expired__upgrade" style="flex-flow: column;">
              <div class="form-group">
                <select name="regtype" v-model="requestForm.customerregtype" class="form-control select2-hidden-accessible">
                        <option value="null" selected disabled>Registration Type</option>
                        <option value="individual">Individual</option>
                        <option value="business">Business</option>
                      </select>
              </div>
              <div class="form-group">
                <select name="buildingtype" class="form-control select2-hidden-accessible" v-model="requestForm.typeOfBuilding">
                        <option value="null" selected disabled>Type of building</option>
                        <option value="bungalow">Bungalow</option>
                        <option value="duplex">Duplex</option>
                        <option value="one storey">One Storey</option>
                        <option value="two storey">Two Storey</option>
                        <option value="others">Others(Charges Apply)</option>
                      </select>
              </div>
              <div class="form-group">
                <select name="rooftype" class="form-control select2-hidden-accessible" v-model="requestForm.roofType">
                        <option value="null" selected disabled>Roof Type</option>
                        <option value="Aluminium">Aluminium</option>
                        <option value="slate">Slate</option>
                      </select>
              </div>
              <b-form-group label="Is roof condition good?">
                <b-form-radio-group v-model="requestForm.roofCondition" :options="binaryOptions" name="roofCondition">
                </b-form-radio-group>
              </b-form-group>
              <b-form-group label="Is the house ready for installation?">
                <b-form-radio-group v-model="requestForm.roofReadiness" :options="binaryOptions" name="houseInstalation">
                </b-form-radio-group>
              </b-form-group>
              <div class="form-group">
                <input type="text" class="form-control form-control-md" v-model="requestForm.roofAge" placeholder="Age of roof">
              </div>
              <div class="form-group">
                <textarea class="form-control form-control-md" v-model="requestForm.roofComment" placeholder="Condition of roof? (Please note that charges apply if roof is discovered to be bad on delivery of system)" cols="30" rows="2"></textarea>
              </div>
              <div class="form-group">
                <b-form-select v-model="requestForm.deviceTypeId" :options="systemTypeOptions" class="mb-3" />
              </div>
              <div class="form-group">
                <textarea class="form-control form-control-md" placeholder="Comment" v-model="requestForm.comment" cols="30" rows="2"></textarea>
              </div>
              <div class="form-group">
                Select 'I agree' to comply with T & C. <a class="btn-primary btn-xs" style="padding: 2px;" target="_blank" href="http://arnergy.com/files/ARNERGY-Terms-and-Conditions-090118.pdf">Read/Download T & C here</a>
                <b-form-checkbox id="tnc" v-model="requestForm.customertnc" value="accepted" unchecked-value="not_accepted">
                  I agree
                </b-form-checkbox>
              </div>
              <can I='create' a='device'>
              <div class="form-group">
                <button class="btn btn-info btn-lg btn-block btn-rounded" type="button" @click="submitRequest">Submit Request</button>
              </div>
              </can>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Autocomplete from "../../utils/Autocomplete";
import { mapGetters } from "vuex";
export default {
  components: {
    Autocomplete
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data() {
    return {
      searchKey: ["first_name", "last_name"],
      displayKey: ["first_name", "last_name"],
      currentUser: null,
      selectedName: "",
      selectedType: null,
      houseInstalation: "",
      selection: "",
      tncstatus: "",
      requestForm: {
        customerregtype: null,
        typeOfBuilding: null,
        roofType: null,
        roofCondition: null,
        roofReadiness: null,
        roofAge: null,
        roofComment: null,
        deviceTypeId: null,
        comment: null,
        customertnc: null
      },
      reqSuccess: false,
      binaryOptions: [
        {
          text: "Yes",
          value: "yes"
        },
        {
          text: "No",
          value: "no"
        }
      ],
      form: {
        email: "",
        name: "",
        food: null,
        checked: []
      },
      foods: [
        {
          text: "Select One",
          value: null
        },
        "Monthly",
        "Outright",
        "Lease2Own"
      ],
      type: [
        {
          text: "Desired Bundle Service",
          value: null,
          disabled: true
        },
        {
          value: "Arnergy 300",
          text: "Arnergy 300"
        },
        {
          value: "Arnergy 1000",
          text: "Arnergy 1000"
        },
        {
          value: "Arnergy 2000",
          text: "Arnergy 2000"
        },
        {
          value: "Arnergy 5000",
          text: "Arnergy 5000"
        }
      ],
      show: true,
      selectedState: null,
      selectedLga: null,
      stateOptions: [
        {
          value: null,
          disabled: true,
          text: "Please select a state"
        }
      ],
      lgaOptions: [
        {
          value: null,
          disabled: true,
          text: "Please select LGA"
        }
      ],
      systemTypeOptions: [
        {
          value: null,
          disabled: true,
          text: "Desired Bundle Service"
        }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "getUserById",
      "getDeviceById",
      "getUsers",
      "getDummy",
      "getDevices",
      "getUserSession"
    ])
  },
  methods: {
    validateRequestForm() {
      for (let [field, value] of Object.entries(this.requestForm)) {
        if (value === null || value === "") {
          return "Please fill all fields!";
        }
      }
      return true;
    },
    submitRequest() {
      if (this.validateRequestForm() === true) {
        delete this.requestForm.customerregtype;
        delete this.requestForm.customertnc;
        this.requestForm.userId = this.getUserSession.id;
        const container = this;
        const HTTP = this.$httpUtils.instance;
        const url = "/device_requests";
        HTTP.post(url, this.requestForm)
          .then(response => {
            // console.log(JSON.stringify(response));
            container.reqSuccess = true;
          })
          .catch(error => {
            var errorMsg = error.response.data.error.details.messages;
            var errTemp = [];
            var keyHooks = Object.keys(errorMsg);
            Object.values(errorMsg).map((x, index) => {
              errTemp[index] = keyHooks[index] + " " + x[0];
            });
            errTemp = Object.values(errTemp).join("<br>");
            this.showErrorMsg({
              message: errTemp
            });
          });
      } else {
        this.showErrorMsg({
          message: this.validateRequestForm()
        });
      }
    },
    onSelected(obj) {
      this.currentUser = obj;
      this.deviceParam.user_id = obj.id;
      this.selectedName =
        this.currentUser.full_name + " " + this.currentUser.last_name;
      // console.log(JSON.stringify(obj));
    },
    onReset(evt) {
      evt.preventDefault();
      /* Reset our form values */
      this.form.email = "";
      this.form.name = "";
      this.form.food = null;
      this.form.checked = [];
      /* Trick to reset/clear native browser form validation state */
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    beforeDeviceDetails() {
      if (this.deviceParam.user_id === null) {
        alert("Please select a user.");
        return false;
      } else {
        return true;
      }
    },
    fetchStates() {
      const HTTP = this.$httpUtils.instance;
      const url = "/states";
      HTTP.get(url)
        .then(response => {
          const statesList = response.data;
          let str = JSON.stringify(statesList);
          str = str.replace(/id/g, "value");
          str = str.replace(/name/g, "text");
          const tempState = JSON.parse(str);
          tempState.unshift({
            value: null,
            disabled: true,
            text: "Please select a state"
          });
          this.stateOptions = tempState;
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    fetchSysTypes() {
      const HTTP = this.$httpUtils.instance;
      const url = "/device_types";
      HTTP.get(url)
        .then(response => {
          const systemTypes = response.data;
          systemTypes.filter(x => {
            x.value = x.id;
            x.text = x.name;
          });

          systemTypes.unshift({
            value: null,
            disabled: true,
            text: "Desired Bundle Service"
          });
          this.systemTypeOptions = systemTypes;
          // console.log(JSON.stringify(systemTypes));
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    fetchLgas(state) {
      if (state !== null) {
        const context = this;
        const HTTP = this.$httpUtils.instance;
        const url = `/states/${state}/lga`;
        HTTP.get(url)
          .then(response => {
            const statesList = response.data;
            let str = JSON.stringify(statesList);
            str = str.replace(/id/g, "value");
            str = str.replace(/name/g, "text");
            const tempLga = JSON.parse(str);
            tempLga.unshift({
              value: null,
              disabled: true,
              text: "Please select LGA"
            });
            context.lgaOptions = tempLga;
          })
          .catch(error => {
            console.log("error", error);
          });
      }
    }
  },
  mounted() {
    // this.fetchStates();
    if(!this.$can('create','device')){
      this.$router.push({ path: "/" });
      return
    }
    this.fetchSysTypes();
  }
};
</script>

<style>
.section-container {
  border-radius: 7px;
  background: #fff;
  -webkit-box-shadow: 0 4px 70px -18px rgba(0,0,0,.2);
  box-shadow: 0 4px 70px -18px rgba(0,0,0,.2);
  margin-bottom: 1.875rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  min-height: 200px;
}

.p-trial-period-expired__upgrade .form-group {
  width: 100%;
}

.custom-control-description {
  margin-left: 12px;
}

#__BVID__36___BV_label_,
#__BVID__40___BV_label_ {
  font-size: 13px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/devices/Request.vue